<template>
    <b-modal v-model="visible" :modal-class="modalClass" :class="[options.modalClass]" hide-footer v-bind:title="title">
        <p class="text-center" v-html="message"></p>
        <div class="modal-footer">    
            <b-button type="submit" @click="visible = false" :variant="options.btnYesVariant" class="btn-block">{{options.btnYes}}</b-button> 
        </div>       
    </b-modal>
</template>

<script>
    export default {
        data: function () {
            return {
                message: '',
                title :'',
                success: null,
                cancel: null,
                modalClass: 'bs-modal-alert colored-header',
                options: {
                    btnYes: 'Ok',
                    btnNo: 'Abbrechen',
                    btnYesVariant: 'primary',
                    btnNoVariant: 'light',
                    modalClass:''
                },
                visible: false,
                value: ''
            };
        },
        methods: {
            show: function (message, title, options = {}, success = null, cancel = null) {             
                this.title = title;
                this.message = message;
                this.options = {...this.options, ...options};
                this.modalClass = this.modalClass + ' '+this.options.modalClass;
                this.visible = true;
            }
        }
    }
</script>

<style lang="scss">
    .bs-modal-alert{
      .modal-footer{
        padding-bottom: 0;
        margin: 1rem -1rem 0 -1rem;
      }
    }
</style> 